import { IMedia } from '../../utils/contentModel';

export interface IChildLineItem {
  description: string;
  price: string;
  value?: string;
}

export interface IProductLineItem {
  sku: string;
  id: string;
  order: number;
  lineItems: IChildLineItem[];
  key: string;
  removable?: boolean;
  planCode?: string;
  parentLineItemId: string;
}

export interface IAdditionalBenefits {
  title: string;
  price: string;
  optIn: boolean;
  desc?: string;
}

export interface IProductLineItemProps {
  childrenLineItems: IProductLineItem[];
}

export interface IProductLineItemsCardProps extends IProductLineItemProps {
  subtotal: string;
  className?: string;
}

export interface ICartSummary {
  cartItemsCount: number;
  totalLineItemQuantity?: number;
  savingsPlanDiscount: string;
  benefits: string;
  shipping: string;
  subTotal: string;
  additionalBenefits: IAdditionalBenefits[];
  cartItems?: ICartItem[];
  savingsPlans?: Array<any>;
  promotions: string;
  employeeDiscount: string;
  total: string;
  savings: string;
  customLineItems: ICustomLineItem[];
  receivedTotal?: string;
}

export interface IAdditionalParams {
  eyeglasses?: { lensWizard?: string; pd?: string };
  childrenSKUs?: TAddToCartChildObject[];
}

export interface ICartItem {
  id: string;
  productId: string;
  variantId: string;
  type: string;
  title: string;
  image: IMedia;
  qty: number;
  price: string;
  orgPrice?: string;
  discount: string;
  promotions: string;
  benefits: string;
  savings: string;
  count?: number;
  childrenLineItems?: IProductLineItem[];
  sku?: string;
  planType?: string;
  dimensions?: any;
  eye?: Eye;
  additionalParams?: IAdditionalParams;
  isAvailable: boolean;
  packSize?: number;
  colour?: string;
  isPrescriptionActive: boolean;
  parentLineItemId?: string;
  isPriceValid: boolean;
  isRXValid: boolean;
  prescriptionId?: string;
  iswebEnabled?: string;
}

export interface IMoney {
  type: string;
  currencyCode: string;
  centAmount: number;
  fractionDigits: number;
}

export interface ICustomFields {
  appliedWithCartDiscount: {
    typeId: string;
    id: string;
  };
  appliedOnLineItem: string;
  deductionCategory: string;
}

export interface ICustom {
  type: {
    typeId: string;
    id: string;
  };
  fields: ICustomFields;
}

export interface ICustomLineItem {
  id: string;
  name: {
    en: string;
  };
  money: IMoney;
  slug: string;
  quantity: number;
  totalPrice: IMoney;
  custom: ICustom;
}

export interface ICartSummaryProps extends IAddedPlans {
  isBottomSheet?: boolean;
  ourGuarantees?: any[];
  cartSummary: ICartSummary;
  onCartSubmit?: () => void;
  onUnavailableCart?: () => void;
  onContinueShopping?: () => void;
  onOpenBottomSheet?: () => void;
}

export interface ISavingsPlanToggleProps extends IAddedPlans {
  discount: string;
}

export interface IAddedPlans {
  addedPlans?: Array<{
    [key: string]: boolean;
  }>;
}

export interface ICart extends ICartSummary {
  cartItems: Array<ICartItem>;
}

export interface ISubscription {
  type: string;
  status: 'active' | 'expired';
  expirationDate: string;
  isActive?: boolean;
}

export enum EAddToCartChildEye {
  left = 'LEFT',
  right = 'RIGHT',
  both = 'BOTH',
}

export type TAddToCartChildObject = {
  sku: string;
  quantity?: number;
  eye?: EAddToCartChildEye;
  labCode?: string;
};

export type TAddToCartChild = string | TAddToCartChildObject;

export interface IAddToCartSkus {
  isExistingParent?: boolean;
  parent: string;
  children?: TAddToCartChild[];
  quantity?: number;
  eye?: Eye;
  pd?: string;
}

export enum Eye {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  BOTH = 'BOTH',
}

export interface IAdjustCartItem {
  lineItemId: string;
  quantity: number;
}
